import { Component, Input } from 'angular-ts-decorators';
import { IFeature } from '@gn-audio/core/api/product-catalogue/models/feature';

import template from './product-item-features.component.html';

@Component({
  selector: 'productItemFeatures',
  template,
})
export class ProductItemFeatures {
  @Input() public features?: IFeature[];
  @Input() public fallback?: string;
}
